import { currentPage } from '../common/layout';
import { banners, commentsCountUpdate, loadCommentsNumber, lloadDisqus, bigImgLazyload, hitPageView, initCoralComments, coralCommentsEdition, initCoralByCommentsBtnEditions} from '../common/utils/fn';
import { getCBSWidget } from '../common/shop/cbs-widget-loader';
import { getStroeerGalleryBanners } from '../common/utils/adv-stroeer-mobile-gallery-loader';
import 'jquery-mousewheel';
import '../common/lightgallery/jquery-lightgallery';
import '../common/lightgallery/jquery-lightgallery-aside';
import '../common/lightgallery/jquery-lightgallery-additional';
import '../common/lightgallery/jquery-lightgallery-topside';
import '../common/lightgallery/jquery-lightgallery-custom-content';
import '../common/msnt/msnt-lightslider.js';
import '../common/lightzoom';
import 'jquery-scrolltie';
import { cmpBubbles } from '../common/cmp-bubbles';
import { msntPhotoThumbGallery } from '../common/msnt/msnt-photo-thumb-gallery';
import { pointsOfInterest } from '../common/widgets/widget-points-of-interest';
import { compareImages } from '../common/widgets/widget-compare-images';
import { faqAccordeon } from '../common/widgets/widget-faq';
import { loadDisqusComments } from '../common/jquery-lazy-load-3rd-party';
import shareTrend from '../common/share-trend';
import '../common/jquery.sticky';
import m1FindVehicleUs from '../common/shop/m1-find-vehicle-us';
import m1FindVehicleEu from '../common/shop/m1-find-vehicle-eu';
import m1FindVehicleByType from '../common/shop/m1-find-vehicle-by-type';
// import '../common/jquery-lazy-load-3rd-party';
// import '../common/modernizr';
// import '../common/player';
// import '../common/lazyload.picture';
// import '../common/lot-linx-car';
// import { renderEbay } from '../common/widgets/widget-ebay';
import { throttle, debounce } from 'throttle-debounce';
import { oneTrust } from '../common/onetrust';
import device from 'current-device';
// import '../common/trinity-audio.js';

currentPage.pageInit = ($page, pageData, pageId) => {
  var $window = $(window),
    $body = $(document.body),
    $page = $('#' + pageId),
    $recommendedBox = $page.find('.recommendedBox'),
    $dataEdtn = $('body').data('edtn'),
    $pageIsRtl = $('body').data('rtl');

  $(
    '#article_box .sidebar, #container_3rd_party_service .sidebar'
  ).stickySidebar({
    containerSelector: '.content-area',
    limitedScroll: true
  });
  bigImgLazyload();

  // $('.embed-item').each(function(index, element) {
  //   var $el = $(element),
  //     code = $el.data('embedCode');
  //   if (code) {
  //     $el.html(decodeURIComponent(code));
  //   }
  // });
  oneTrust.initEmbeds($('.content-area-box'));

  msntPhotoThumbGallery();

  var slideShowBannerTimeout = null;
  var $slide_show_sidebar_banner = $('#slide_show_sidebar_banner');
  function reloadSlideShowBanners() {
    if($slide_show_sidebar_banner.length){
      clearTimeout(slideShowBannerTimeout);
      slideShowBannerTimeout = setTimeout(function() {
        $slide_show_sidebar_banner.find('.ap').removeAttr('data-ready').empty();
        banners($slide_show_sidebar_banner);
      }, 1000);
    }
  }
  var $articleSlideshowPhotosList = $('.m1-article-slideshow-photos-list'),
    $articleSlideshowPhotosListInPhotos = $articleSlideshowPhotosList.find(
      '.m1-article-slideshow-photos-related-content'
    );

  function gtmSlideshowHit(id) {
    if ('gtmDataLayer' in window && id) {
      gtmDataLayer.push({
        event: 'popupPhotoGallaryEntityChanged',
        entityType: 'photo',
        entityId: id,
      });
    }
  }
  if ($articleSlideshowPhotosList.length) {
    const $slideshow = $('.m1-article-slideshow, .m1-article-slideshow');

    var $items = $articleSlideshowPhotosList.find('.item');
    var $relatedWidget = $(
      '.postContent .postBody section[data-widget="related-content"]'
    ).first();
    if ($relatedWidget.length) {
      $items.each(function(i, v) {
        var $item = $(v);
        if ($item.find('section[data-widget="related-content"]').length === 0) {
          $relatedWidget.clone(true, true).appendTo($item);
          bigImgLazyload();
        }
      });
    }

    $slideshow.length ? $slideshow.trigger('focus') : null;

    $slideshow.on(
      'click keyup',
      function(event) {
        var $slideShowOn = $('.m1-article-slideshow-on, .m1-article-slideshow-on');
        var slideShowOn = $slideShowOn.length;
        var pageUrl = $slideshow.data('page-url');
        const ArrowNext = $pageIsRtl ? 'ArrowLeft' : 'ArrowRight';
        const ArrowPrev = $pageIsRtl ? 'ArrowRight' : 'ArrowLeft';

        const prevEventers = event.target.classList.contains('m1-article-slideshow-prev') ||
                      event.target.classList.contains('m1-article-slideshow-button-prev') ||
                      event.target.classList.contains('m1-article-slideshow-button-bottom-prev') ||
                      event.key === ArrowPrev;
        const nextEventers = event.target.classList.contains('m1-article-slideshow-next') ||
                      event.target.classList.contains('m1-article-slideshow-button-next') ||
                      event.target.classList.contains('m1-article-slideshow-button-bottom-next') ||
                      event.key === ArrowNext;
        if (slideShowOn) {
          var $slideShowList = $slideShowOn
            .find('.m1-article-slideshow-photos-list, .m1-article-slideshow-photos-list ')

          if ($slideShowList.length) {
            var $currentSlide = $slideShowList.find('.item.current');

            if ($currentSlide.length) {
              var $next = [];

              if (prevEventers) {
                $next = $currentSlide.prev();
              } else if (nextEventers) {
                $next = $currentSlide.next();
              } else {
                return;
              }

              if ($next.length) {
                var id = $next.data('id');

                if (id && pageUrl) {
                  var adv = $currentSlide.data('adv');
                  if (adv !== undefined) {
                    var $currentSlideAd = $currentSlide.find('.adv-box');

                    if (adv) {
                      if (!$currentSlideAd.length) {
                        $currentSlideAd = $(
                          '<div class="adv-box"></div>'
                        ).appendTo(
                          $currentSlide.find('.m1-article-slideshow-photo')
                        );
                        var $slide_show_sidebar_banner = $(
                          '#slide_show_sidebar_banner'
                        );
                        $slide_show_sidebar_banner
                          .find('.ap')
                          .clone()
                          .removeAttr('data-ready')
                          .empty()
                          .appendTo($currentSlideAd);
                      }
                      $currentSlide.addClass('show-ad');
                      $currentSlideAd
                        .find('.ap')
                        .empty()
                        .removeAttr('data-ready');
                      banners($currentSlideAd);
                      $currentSlide.data('adv', false);
                      return;
                    } else {
                      $currentSlide.data('adv', true);
                    }
                    $currentSlide.removeClass('show-ad');
                  }
                  //banner insert
                  $currentSlide.removeClass('current');
                  $next.addClass('current');
                  history.replaceState({}, null, pageUrl + id + '/');
                  gtmSlideshowHit(id);
                  hitPageView(pageUrl + id + '/');
                  reloadSlideShowBanners();
                }
              } else {
                $slideShowOn
                  .removeClass('m1-article-slideshow-on')
                  .addClass('m1-article-slideshow-off');
                if (pageUrl) {
                  history.replaceState({}, null, pageUrl);
                  hitPageView(pageUrl);
                }
                $currentSlide.removeClass('current');
                $slideShowList.each(function(){
                  $(this).find('.item')
                  .first()
                  .addClass('current');
                })

                reloadSlideShowBanners();
              }
            }
          }
        } else {
          var $slideShow = $('.m1-article-slideshow-off');
          if ($slideShow.length && nextEventers) {
            var $slideShowList = $slideShow
              .find('.m1-article-slideshow-photos-list')
              .first();
            if ($slideShowList.length) {
              var $currentSlide = $slideShowList.find('.item.current');
              if ($currentSlide.length) {
                var id = $currentSlide.data('id');
                if (id && pageUrl) {
                  history.replaceState({}, null, pageUrl + id + '/');
                  gtmSlideshowHit(id);
                  hitPageView(pageUrl + id + '/');
                  $slideShow
                    .addClass('m1-article-slideshow-on')
                    .removeClass('m1-article-slideshow-off');
                  reloadSlideShowBanners();
                }
              }
            }
          }
        }
      }
    );

    $slideshow.on('slide.next', event => {
      const $slide = $slideshow.find('.current');
      $slide.find('.m1-article-slideshow-next').trigger('click');
    });

    $slideshow.on('slide.prev', event => {
      const $slide = $slideshow.find('.current');
      $slide.find('.m1-article-slideshow-prev').trigger('click');
    });
    /**
     * Swipe
     */
    class Point {
      constructor(x, y) {
        this._x = x || 0;
        this._y = y || 0;
      }

      get x() {
        return this._x;
      }

      set x(x) {
        this._x = x;
      }

      get y() {
        return this._y;
      }

      set y(y) {
        this._y = y;
      }
    }

    const distanceMinX = 50;
    const distanceMaxY = 250;
    const timeSwipeMax = 250;

    let isSwipe = false;
    let direction = 0;
    let timeStart = 0;
    let distance = new Point();
    let start = new Point();
    let end = new Point();

    $slideshow.on('touchstart', '.m1-article-slideshow-photo', function(event) {
      let touch = event.changedTouches[0];

      start.x = touch.clientX;
      start.y = touch.clientY;

      direction = 0;
      timeStart = new Date().getTime();
    });

    $slideshow.on('touchmove', '.m1-article-slideshow-photo', function(event) {
      let touch = event.changedTouches[0];
      let isScroll =
        Math.abs(touch.clientX - start.x) < Math.abs(touch.clientY - start.y);

      if (!isScroll) {
        event.preventDefault();
      }
    });

    $slideshow.on('touchend', '.m1-article-slideshow-photo', function(event) {
      let touch = event.changedTouches[0];

      end.x = touch.clientX;
      end.y = touch.clientY;

      distance.x = end.x - start.x;
      distance.y = end.y - start.y;

      direction = distance.x > 0 ? -1 : 1;

      isSwipe =
        new Date().getTime() - timeStart <= timeSwipeMax &&
        Math.abs(distance.x) >= distanceMinX;

      if (!isSwipe) {
        return;
      }

      if (Math.abs(distance.y) >= distanceMaxY) {
        return;
      }

      if (direction === 1) {
        $slideshow.trigger('slide.next');
      } else if (direction === -1) {
        if (
          $(this)
            .parent()
            .is('.m1-article-slideshow-main-photo-box')
        ) {
          return;
        }
        $slideshow.trigger('slide.prev');
      }
      direction = 0;
    });

    /**
     * Slide width animation
     */
    /*
    const distanceMinX = 70;
    const moveThrottle = throttle(1000 / 60, moveHandle);

    let direction = 0;
    let distance = new Point();
    let start = new Point();
    let animationID;
    let stop = false;

    function moveHandle(event) {
      if (stop) return;

      const touch = event.changedTouches[0];

      let X;

      distance.x = Math.abs(Math.abs(start.x) - Math.abs(touch.pageX));
      distance.y = Math.abs(Math.abs(start.y) - Math.abs(touch.pageY));

      X = start.x - touch.pageX;

      direction = X > 0 ? -1 : 1;

      const $slide = $slideshow.find('.current');
      let $nextSlide;

      if (distance.x > distance.y + 10) {
        if (direction === 1) {
          $nextSlide = $slide.prev();

          if (!$nextSlide.length) {
            $nextSlide = $slideshow.find('.item').last();
          }

          $nextSlide.addClass('preShow');
        } else if (direction === -1) {
          $nextSlide = $slide.next();

          if (!$nextSlide.length) {
            $nextSlide = $slideshow.find('.item').first();
          }

          $nextSlide.addClass('preShow');
        }

        $slide.addClass('preHide');

        animationID = requestAnimationFrame(() => {
          $slide.css({
            transform: `translate3d(${-X}px, 0, 0)`,
            'box-shadow': `0 0 ${Math.abs(X) / 5}px rgba(0, 0, 0, 0.15)`,
          });

          $nextSlide.css({
            opacity: Math.abs(X) / 300,
          });
        });
      }
    }

    function reset(slide) {
      const $slide = slide || $slideshow.find('.current');
      let animationReset;

      cancelAnimationFrame(animationID);
      let $items = $slideshow.find('.item');
      animationReset = requestAnimationFrame(() => {
        $items.removeClass('preHide').removeClass('preShow');
        $items.css({
          opacity: 1,
          transform: `translate3d(0, 0, 0)`,
          'box-shadow': 'none',
        });
        cancelAnimationFrame(animationReset);
      });
    }

    $slideshow.on('touchstart', '.m1-article-slideshow-photo', event => {
      stop = false;
      let touch = event.changedTouches[0];

      start.x = touch.pageX;
      start.y = touch.pageY;

      direction = 0;
    });

    $slideshow.on('touchend', '.m1-article-slideshow-photo', event => {
      stop = true;
      const touch = event.changedTouches[0];
      const $slide = $slideshow.find('.current');

      let X = start.x - touch.pageX;
      direction = X > 0 ? -1 : 1;

      if (distanceMinX < Math.abs(start.x - touch.pageX)) {
        $slide.css({
          transform: `translate3d(${direction * 150}%, 0, 0)`,
        });

        if (direction === 1) {
          $slideshow.trigger('slide.prev');
        } else if (direction === -1) {
          $slideshow.trigger('slide.next');
        }
      }
      reset();
    });

    $slideshow.on('touchmove', '.m1-article-slideshow-photo', event => {
      moveThrottle(event);
    });
    */
  }
  var $postBox = $('#post_box'),
    $postTopInfo = $postBox.find('.postTopInfo'),
    layout_header_height = $('#layout_header').height() || 0,
    $post_sidebar = $('#post_sidebar'),
    is_stick_share = 0,
    is_hide_aside = 0;

  var $liveTextIframe = $postBox.find('iframe[src*="/live-text/embed/"]');
  $window.on('message', function(event) {
    event = event.originalEvent;

    var origin = event.origin || event.originalEvent.origin;

    if (
      !/ntlbss\.com|motorsport\.com/.test(origin) ||
      (event.data &&
        event.data.constructor !== Object &&
        event.data.type !== 'live-text-resize')
    )
      return;

    $liveTextIframe.height(event.data.height);
  });

  // var $sharesTrend = $('#shares_speed_graph'),
  // 	shareLineData = fn.getSharesGraphPoints($sharesTrend, $sharesTrend.data('shares')),
  // 	d3LineFn;

  // if (shareLineData.length) {
  //       d3LineFn = d3.svg.line()
  //           .x(function(d) { return d.x; })
  //           .y(function(d) { return $sharesTrend.height() - d.y; })
  //           .interpolate("monotone");

  //       $('#shares_line').attr('d', d3LineFn(shareLineData));
  //   }

  shareTrend();

  // easy way to disable full width articles without build
  if ($body.hasClass('fullwidthArticles')) {
    $window.on('scroll.hide_aside', function() {
      if (
        document.documentElement.clientWidth >= 1024 &&
        $post_sidebar.length
      ) {
        var postSidebarRect = $post_sidebar[0].getBoundingClientRect();

        if (postSidebarRect.bottom < 0) {
          // + document.documentElement.clientHeight
          if (is_hide_aside == 0) {
            $postBox.addClass('hide-aside');
          }
          is_hide_aside = 1;
        } else {
          if (is_hide_aside == 0) {
            $postBox.removeClass('hide-aside');
          }
          is_hide_aside = 0;
        }
      }
    });
  }

  var $competitors = [];
  function initCompetitorsSlider() {
    $competitors = $('#competitors');
    if ($competitors.length) {
      $competitors.lightSlider({
        loop: true,
        addClass: 'imageInlineGallery',
        item: 3,
        slideMargin: 25,
      });
    }
  }
  var clientWidth = document.documentElement.clientWidth;
  if (clientWidth >= 768) {
    initCompetitorsSlider();
  }

  $window.on('resize', function() {
    var clientWidth = document.documentElement.clientWidth;
    if (clientWidth < 768 && $competitors.length) {
      $competitors.destroy();
      $competitors = [];
    }
    if (clientWidth >= 768 && $competitors.length == 0) {
      initCompetitorsSlider();
    }
  });

  // var $articlePoster = $('.scrollTieBox');

  // $articlePoster.scrollTie({
  //   property: 'translateY',
  //   delay: function(el) {
  //     return 600;
  //   },
  //   stopAtValue: document.documentElement.clientHeight,
  //   speed: isTouch ? 0.15 : 0.3,
  //   //manualInit: true
  // });

  // let showDisqusButton = document.getElementById('show-disqus');
  let lloadDisqusEditions = ['us', 'ev_us', 'it', 'de', 'fr', 'id', 'ru', 'ev_fr', 'ev_it', 'ev_ru', 'om', 'ra_us', 'ev_br', 'br', 'ra_us'];
  let coralEditions = ['ra_us', 'fr', 'dp'];
  //smooth anchor scroll
  $('.disqus-comment-count').click(function(event) {
    var showDisqusButton = $('.show-disqus');
    var ifVisible = showDisqusButton.data('visible');
    event.preventDefault();
    event.stopPropagation();

    var string = $(this).attr('href').split('/');
    var stringLength = string.length;
    var anchor = string[stringLength-1];

    var distanceToAnchor = $(anchor).offset().top;
    var distanceToAnchorNew;
    var callTimes = 0;
    let callTimesMax = $dataEdtn === 'ra_us' ? 2 : 6;

    $('html, body').animate({
      scrollTop: $(anchor).offset().top + 500
    }, 500);

    const resizeObserver = new ResizeObserver((entries, observer) => {
      for(let entry of entries){
          if (callTimes < callTimesMax) {
            calcResizeTimes();
          } else {
            resizeObserver.unobserve(document.querySelector('#post_box'));
            resizeObserver.unobserve(document.querySelector('#container_3rd_party_service'));
          }
      }
    })

    resizeObserver.observe(document.querySelector('#post_box'));
    resizeObserver.observe(document.querySelector('#container_3rd_party_service'));

    function calcResizeTimes() {
      distanceToAnchorNew = $(anchor).offset().top + 500;

      if(distanceToAnchor != distanceToAnchorNew) {
        $('html, body').animate({
          scrollTop: distanceToAnchorNew
        }, 500);
      }
      callTimes++;
    }

    if (lloadDisqusEditions.includes($dataEdtn) && ifVisible) {
      if (coralCommentsEdition.includes($dataEdtn)) {
        initCoralComments();
      } else {
        lloadDisqus();
      }
      showDisqusButton.data('visible', false);
      showDisqusButton.hide();
    }
  });

  window.addEventListener('message', function(e){
    let data = e.data;
    if (data === 'newComment') {
      gtmDataLayer.push({
        event: data,
      });
    }
  })

  pointsOfInterest();
  compareImages();
  faqAccordeon();
  // if (adplayer && typeof adplayer.init === 'function') {
  // 	adplayer.init();
  // }

  cmpBubbles.init({
    minWidth: 640,
    error: function(data, element, response, textStatus, jqXHR) {
      cmpTrayAlert.show(
        jqXHR.responseJSON &&
        jqXHR.responseJSON.constructor === Object &&
        jqXHR.responseJSON.message
          ? jqXHR.responseJSON.message
          : 'Bad response (JSON)',
        'error',
        30
      );
    },
  });

  let facebookWrapper = document.getElementsByClassName('facebook-video-wrapper')[0];

  if (facebookWrapper) {

    let fbSizer = document.querySelector('.facebook-video-wrapper .sizer');
    let videoIframe = document.querySelector('.facebook-video-wrapper iframe');

    let fbSizerHeight = fbSizer.offsetHeight;
    let videoIframeWidth = videoIframe.getAttribute('width');
    let videoIframeHeight = videoIframe.getAttribute('height');
    let iframeAspectRatio = videoIframeHeight/videoIframeWidth;

    if (iframeAspectRatio == 1 ) {
      videoIframe.height = fbSizerHeight;
      videoIframe.width = fbSizerHeight;
    } else if (iframeAspectRatio == 0.5625) {
      facebookWrapper.classList.add('facebook-iframe-sizer');
    } else if (iframeAspectRatio > 1) {
      videoIframe.height = fbSizerHeight;
      videoIframe.width = fbSizerHeight/iframeAspectRatio;
    } else {
      videoIframe.height = fbSizerHeight;
      facebookWrapper.classList.add('facebook-iframe-sizer');
    }
  }

  var $videoBoxWrapper = $('.videoBoxArticle .videoBoxArticle-wrapper');
  var $videoWrapper = $('.videoBoxArticle .video-player');

  var enableVideoScroll;

  if ($videoBoxWrapper.length && ($videoBoxWrapper.hasClass('youtube-video-wrapper') || $videoBoxWrapper.hasClass('mstv-video-wrapper')) && (device.type == 'desktop' || device.type == 'mobile')) {
    enableVideoScroll = true;
  }

  if (enableVideoScroll) {
    var videoHeight = $videoWrapper.outerHeight();

    $window.on('scroll', function() {
      if (window.notStickThisVideo) {
        if ($videoWrapper.hasClass('stick')) {
          $videoWrapper.removeClass('stick');
        }

        if ($('body').hasClass('custom-zindex')) {
          $('body').removeClass('custom-zindex');
        }
        return;
      }

      var closeVideoScrollButton = $('.video-player.stick .video-player-close');
      closeVideoScrollButton.on('click', function() {
        window.notStickThisVideo = true;
        let player = $videoBoxWrapper.find('iframe').get(0);
        let command4Youtube = {
          "event": "command",
          "func": "pauseVideo"
        }
        let command4Mstv = {
          player:{
            action: 'pause',
            value: ''
          }
        }

        if (player != undefined) {
          if ($videoBoxWrapper.hasClass('youtube-video-wrapper')) {
            player.contentWindow.postMessage(JSON.stringify(command4Youtube), "*");
          } else if ($videoBoxWrapper.hasClass('mstv-video-wrapper')) {
            player.contentWindow.postMessage(command4Mstv, "*");
          }
        }

        if ($videoWrapper.hasClass('stick')) {
          $videoWrapper.removeClass('stick');
        }

        if ($('body').hasClass('custom-zindex')) {
          $('body').removeClass('custom-zindex');
        }
      })

      var windowScrollTop = $window.scrollTop();
      var videoBottom = videoHeight + $videoBoxWrapper.offset().top;
      var stopScrollPoint = Math.floor($(document).height() - $(document).scrollTop() - $(window).height());

      if ( windowScrollTop > videoBottom) {
        // $videoBoxWrapper.height(videoHeight);
        if (
          $videoBoxWrapper.hasClass('youtube-video-wrapper') &&
          $dataEdtn === 'us'
        ) {
          $videoWrapper.removeClass('stick');
          $('body').removeClass('custom-zindex');
        } else {
          $videoWrapper.addClass('stick');
          $('body').addClass('custom-zindex');
        }
      } else {
        // $videoBoxWrapper.height('auto');
        $videoWrapper.removeClass('stick');
        $('body').removeClass('custom-zindex');
      }

      //stop scroll before some point in the bottom
      // if (stopScrollPoint < 50) {
      //   $videoWrapper.addClass('stop_stick');
      // } else {
      //   $videoWrapper.removeClass('stop_stick');
      // }
    });
  }

  if ($videoWrapper.length) {
    const $playBtn = $('.play-button-svg', $videoWrapper);
    $playBtn.on('click', function() {
      $videoWrapper.html('<div class="video-player-close icon-cross"></div><iframe allowfullscreen frameborder="0" allow="autoplay" src="' + $videoWrapper.data('video-url') + '"></iframe>')
    })
  }

  // show insider block
  /*(function() {
    var $articleContent = $('#article_box .postBody'),
      // $articleChildrens = $articleContent.children('p'),
      // articleChildrensCount = $articleChildrens.length,
      $insiderForm = $('#motor1_insider_form'),
      middle;

    // show register form only when register pop-up already shown
    // should be disabled if there is no register pop-up
    // var registerLightBox = $.cookie('reglb');
    // if (isCookieSupported && !registerLightBox) return;

    if (!$insiderForm.length) return;

    // if (articleChildrensCount >= 2) {
    // 	middle = Math.floor(articleChildrensCount / 2);
    // } else {
    // 	middle = 2;
    // }

    // $articleChildrens.eq(middle - 1).after($insiderForm);
    $articleContent.append($insiderForm);
    $insiderForm.show();

    $insiderForm.validate({
      submitHandler: function(form) {
        var $form = $(form),
          $emailField = $form.find('input[type="email"]');

        fn.showRegisterPopup({
          email: $emailField.val(),
        });
      },
    });
  })(); */

  // show register popup if user not registered
  // don't forget to update insider block
  /*
      (function() {
        var registerLightBox = $.cookie('reglb');

        if (!window.isAuthorized && isCookieSupported && !registerLightBox) {
          setTimeout(fn.showRegisterPopup, 5000);
        }
    })();
    */
  // if(fn && fn.lotLinx && typeof fn.lotLinx === "function") {
  //     fn.lotLinx();
  // }

  // console.log($('.de-rss-container').data('src'));
  if ($dataEdtn == 'de' || $dataEdtn == 'ev_de') {
    getStroeerGalleryBanners().then((api) => {
      api.initDeMobileGalleryBanners();
    });
  }

  //let ebayWrapper = document.querySelector('.ebay-widget');

  // if ($dataEdtn == 'it' && ebayWrapper) {
  //   renderEbay();
  // }

  // function dataSrcReplacer() {
  //   console.log('helloworld');
  //   var vidDefer = document.getElementsByTagName('iframe');
  //   console.log(vidDefer);
  //   for (var i=0; i<vidDefer.length; i++) {
  //     if(vidDefer[i].getAttribute('data-src')) {
  //        vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
  //     }
  //   }
  // }

  // window.onload = dataSrcReplacer;
  $('.author-js-link').on('click', function () {
    window.location.href = $(this).data('href');
  });

  if ($('.lightzoom').length > 0) {
     $( '.lightzoom' ).lightzoom({
      speed:                 100,   // скорость появления
      imgPadding:            1,    // значение отступа у изображения
      overlayOpacity:        '0.5', // прозрачность фона (от 0 до 1)
      viewTitle:             false, // true, если надо показывать подпись к изобажению
      isOverlayClickClosing: true, // true, если надо закрывать окно при клике по затемненной области
      isWindowClickClosing:  true, // true, если надо закрывать окно при клике по любой области
      isEscClosing:          true, // true, если надо закрывать окно при нажатии на кнопку Esc
      boxClass:              '',    // позволяет задавать класс окну обертке (с версии 1.1.0)
      overlayColor:          '',    // позволяет задавать цвет фону (с версии 1.1.0)
      titleColor:            '',    // позволяет задавать цвет подписи (с версии 1.1.0)
    });
  }

  // DEV: Section Pages: html and css structure for Pagination
  // const setIframeModifier = function () {
  //   const embedItems = document.querySelectorAll('.embed-item');
  //   if (embedItems.length === 0) {
  //     return;
  //   }
  //   return [...embedItems].map((item) => {
  //     const itemEl = item.firstElementChild;
  //     if (itemEl.nodeName === 'IFRAME') {
  //       const itemSrc = itemEl.getAttribute('src');
  //       const itemHeight = itemEl.getAttribute('height');
  //       const itemWidth = itemEl.getAttribute('width');
  //       const iframeAspectRatio = itemHeight/itemWidth;
  //       if (iframeAspectRatio === 1 && itemSrc.includes('facebook.com/plugins')) {
  //         item.classList.add('embed-item_fb');
  //       }
  //     }
  //   });
  // };

  // window.addEventListener('load', setIframeModifier);

  // let embedItems = document.querySelectorAll('.embed-item');
  // console.log(embedItems);
  // if(embedItems.length) {
  //   const config = {
  //     attributes: true,
  //     childList: true,
  //     subtree: true
  //   };

  //   const callback = function(mutationsList, observer) {
  //     // console.log('called');
  //     for (let mutation of mutationsList) {
  //         if (mutation.type === 'childList' ||  mutation.type === 'subtree') {
  //             console.log(mutation.target);
  //             console.log('A child node has been added or removed.');
  //         }
  //     }
  //   };

  //   const observer = new MutationObserver(callback);

  //   for (let embedItem of embedItems) {

  //     if (embedItem.innerHTML !== '') {
  //       console.log(embedItem.innerHTML);
  //       return;
  //     }
  //     observer.observe(embedItem, config);
  //   }
  // }
  m1FindVehicleUs();
  m1FindVehicleEu();
  m1FindVehicleByType();

  commentsCountUpdate();
  loadDisqusComments();

  if ($dataEdtn == 'us' || $dataEdtn == 'ev_us') {
    getCBSWidget().then((api) => {
      api.cbsWidget();
    });
  }
  //bannerLazyload();

  if (!coralCommentsEdition.includes($dataEdtn)) loadCommentsNumber();
  const coralContainer = $('#coral_thread');
  const showCoralCommentsBtn = document.querySelector('#show-disqus');

  if (coralCommentsEdition.includes($dataEdtn) && initCoralByCommentsBtnEditions.includes($dataEdtn) && coralContainer.length) {
    showCoralCommentsBtn.addEventListener('click', () => {
      initCoralComments();
      showCoralCommentsBtn.remove();
    });
  } else if (coralCommentsEdition.includes($dataEdtn) && coralContainer.length) {
    initCoralComments();
  }
  $('.photo-title a').on('click', function(e) {
    e.stopPropagation();
  });
  
  const authorSocialsItems = document.querySelectorAll('.author-socials-item');

  if (authorSocialsItems.length > 0) {
    authorSocialsItems.forEach((item) => {
      item.addEventListener('click', (event) => {
        const outlink = event.currentTarget.dataset.outlink;
        
        const decodedOutlink = new TextDecoder('utf-8').decode(Uint8Array.from(atob(outlink), c => c.charCodeAt(0)));
        
        window.open(decodedOutlink, '_blank');
      });
    });
  }
};
